import { useState, useEffect, useCallback } from 'react';
import { verificacionOmeService } from '../services/verificacionOmeService';

/**
 * Hook que carga las verificaciones de OME pendientes para la bandeja
 * "OME por verificar" del Personal de Recepción.
 *
 * Maneja loading / error / data y expone una función `refrescar` para
 * volver a consultar la lista. El error se muestra como mensaje claro
 * al usuario (no técnico).
 *
 * @param {string} [estado] Filtro opcional por estado (ej. 'pendiente').
 */
export const useVerificacionesOme = (estado) => {
  const [verificaciones, setVerificaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const cargar = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await verificacionOmeService.listarPendientes(estado);
      setVerificaciones(Array.isArray(data) ? data : []);
    } catch {
      setError('No pudimos cargar las verificaciones de OME. Volvé a intentarlo en unos instantes.');
      setVerificaciones([]);
    } finally {
      setLoading(false);
    }
  }, [estado]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  return { verificaciones, loading, error, refrescar: cargar };
};

export default useVerificacionesOme;
